<script>
import PasswordRecoveryComponent from '../features/PasswordRecoveryComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'PasswordRecoveryView',
  components: {
        'brand-logo': BrandLogo,},
  mixins: [PasswordRecoveryComponent],
};
</script>

<template>
  <div class="public-page">
    <div class="public-page__background">
      <!-- Left Branding Panel -->
      <div class="public-page__branding">
        <div class="public-page__branding-content">
          <router-link
            to="/"
            class="public-page__logo-link"
          >
            <brand-logo
              variant="light"
              size="lg"
              stacked
            />
          </router-link>
          <div class="public-page__branding-text">
            <h1>Recupera tu acceso</h1>
            <p>¿Olvidaste tu contraseña? Ingresa tu correo y te ayudaremos a restablecerla.</p>
          </div>
        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="public-page__form-panel">
        <div class="public-page__card">
          <!-- Card Header -->
          <div class="public-page__card-header">
            <div class="public-page__card-header-icon">
              <i class="uil uil-key-skeleton-alt" />
            </div>
            <h2>Recuperar Contraseña</h2>
            <p>Ingresa tu correo para recibir un enlace de recuperación</p>
          </div>

          <!-- Info -->
          <div class="public-page__info">
            <i class="uil uil-info-circle" />
            Te enviaremos un correo con un enlace para restablecer tu contraseña de forma segura.
          </div>

          <!-- Form -->
          <el-form
            ref="formData"
            v-loading="isFormProcessing"
            :model="formData"
            :rules="rules"
            status-icon
            :label-position="'top'"
            :element-loading-text="formProcessingMessage"
            class="public-page__form"
          >
            <el-form-item
              label="Correo Electrónico"
              prop="email"
            >
              <el-input
                v-model="formData.email"
                type="email"
                placeholder="Ingresa tu correo electrónico"
                size="large"
                @keyup.enter="onSend('formData')"
              >
                <template #prefix>
                  <el-icon><Message /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <div class="public-page__submit">
              <el-button
                type="primary"
                size="large"
                class="public-page__submit-btn"
                :loading="isFormProcessing"
                @click="onSend('formData')"
              >
                <i class="uil uil-envelope-send" />
                Enviar Enlace
              </el-button>
            </div>
          </el-form>

          <!-- Footer -->
          <div class="public-page__card-footer">
            <p>
              ¿Recordaste tu contraseña?
              <router-link to="/login">
                Inicia sesión
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

